// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2Vtv4","legacyBtn":"MutateMid_legacyBtn__a3E4R"};